import { graphql } from 'msw';

import { SocialSignInGoogleOneTapMutation } from '../AuthModal/section/SignIn/queries/googleOneTap.generated';
import { generateUserHandler } from './user';

export const generateGoogleOneTapHandler = (
    response: SocialSignInGoogleOneTapMutation
) => {
    return graphql.mutation<SocialSignInGoogleOneTapMutation>(
        'socialSignInGoogleOneTap',
        (_, res, ctx) => {
            return res(ctx.data(response));
        }
    );
};

export const defaultGoogleOneTapHandler = generateGoogleOneTapHandler({
    socialSignInGoogleOneTap: { success: 1 }
});

export const googleOneTapFailHandler = generateGoogleOneTapHandler({
    socialSignInGoogleOneTap: { success: 0 }
});

export const defaultGoogleOneTapUserHandler = generateUserHandler({
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-26 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['googleonetap'],
    registered: true
});

export const googleOneTapNewUserHandler = generateUserHandler({
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-27 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['googleonetap'],
    registered: true
});
